import { reactive } from "vue";
import { NyukyoshaApi } from "./nyukyosha/NyukyoshaApi";
import { KeiyakushaApi } from "./keiyakusha/KeiyakushaApi";
import { AdminInformationApi } from "./information/AdminInformationApi";
import { AccountApi } from "./account/AccountApi";
import { RsyncApi } from "./rsync/RsyncApi";
/** 管理者用APIのファサード */
class Api {
    nyukyosha = new NyukyoshaApi();
    adminInfomation = new AdminInformationApi();
    keiyakusha = new KeiyakushaApi();
    account = new AccountApi();
    rsync = new RsyncApi();
}
export const adminApi = reactive(new Api());
